import { gql } from '@apollo/client';

import { OutcomesFragment } from 'approot/shared/graphql/outcomes/outcomes.graphql';

export const ADD_LESSON_OUTCOME = gql`
  mutation AddLessonOutcome($input: AddLessonOutcomeInput!) {
    addLessonOutcome(input: $input) {
      id
      outcomes {
        ...OutcomesFragment
        description
        metaInfo
      }
      performanceExpectations {
        ...OutcomesFragment
        description
        metaInfo
      }
    }
  }
  ${OutcomesFragment}
`;

export const DELETE_LESSON_OUTCOME = gql`
  mutation DeleteLessonOutcome($input: DeleteLessonOutcomeInput!) {
    deleteLessonOutcome(input: $input) {
      id
      outcomes {
        ...OutcomesFragment
        description
        metaInfo
      }
      performanceExpectations {
        ...OutcomesFragment
        description
        metaInfo
      }
    }
  }
  ${OutcomesFragment}
`;

export const lessonOutcomesFragment = gql`
  fragment LessonOutcomesFragment on Lesson {
    years {
      name
    }
    subjects {
      name
    }
    outcomes {
      ...OutcomesFragment
      description
      groupLabel
      metaInfo
    }
    performanceExpectations {
      ...OutcomesFragment
      description
      groupLabel
      metaInfo
    }
  }
  ${OutcomesFragment}
`;
